export const APARTMENT_MONTHS_LIST = [
  "january",
  "february-early",
  "february-lately",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
] as const;

export type MonthKey = (typeof APARTMENT_MONTHS_LIST)[number];
export type MonthValue = {
  month: number;
  day: number;
};

export type IApartmentMonth = Record<MonthKey, MonthValue>;

export const APARTMENT_MONTHS_VALUES: IApartmentMonth = {
  january: {
    month: 1,
    day: 1,
  },
  "february-early": {
    month: 2,
    day: 1,
  },
  "february-lately": {
    month: 2,
    day: 28,
  },
  march: {
    month: 3,
    day: 1,
  },
  april: {
    month: 4,
    day: 1,
  },
  may: {
    month: 5,
    day: 1,
  },
  june: {
    month: 6,
    day: 1,
  },
  july: {
    month: 7,
    day: 1,
  },
  august: {
    month: 8,
    day: 1,
  },
  september: {
    month: 9,
    day: 1,
  },
  october: {
    month: 10,
    day: 1,
  },
  november: {
    month: 11,
    day: 1,
  },
  december: {
    month: 12,
    day: 1,
  },
};

export const TOGGLE_KEYS = [
  "lo-shoo",
  "sectors-diagram",
  "tai-shoo",
  "sui-po",
  "year-sha",
  "month-sha",
  "noble-stars",
  "middle-12-mountains",
  "border-12-mountains",
  "move-mountains-labels",
  "current-stars",
] as const;

export type ToggleKey = (typeof TOGGLE_KEYS)[number];
